import script from "./Address.vue?vue&type=script&setup=true&lang=js"
export * from "./Address.vue?vue&type=script&setup=true&lang=js"

import "./Address.vue?vue&type=style&index=0&id=61a779c3&lang=scss&scoped=true"

import exportComponent from "D:\\work\\project\\万禾项目\\东智\\dongzhistore\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a779c3"]])

export default __exports__